import React, { Component } from 'react'
import moment from 'moment';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { withFormsy } from 'formsy-react';
import './DatetimePicker.less'

var yesterday = moment().subtract(1, "day");
function valid(current) {
  return current.isAfter(yesterday);
}

class DatetimePicker extends Component {
    
    onChange = (selectedDate) => {
        this.props.setValue(selectedDate);
        if (this.props.onChange) {
            this.props.onChange(selectedDate);
        }

    }
    render() {
        console.log(this.props);
        return (
            <div className={`datetimepicker ${!this.props.isValid ? 'error': ''}`}>
                <Datetime isValidDate={valid} onChange={this.onChange}
                    inputProps={{placeholder: this.props.placeholder, readOnly: false, style:{textAlign: 'left'}}}


                />
                {this.props.isFormSubmitted && !this.props.isValid &&
                <span style={{ color: '#FF0000' }}>{this.props.errorMessage ? this.props.getErrorMessage() : 'Invalid value'}</span>
                }
            </div>
        )
    }
}

export default withFormsy(DatetimePicker)

